export function Header() {
  return (
    <header className="bg-white shadow-sm">
      <div className="container-wrapper">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              className="h-8 w-8"
              src="/favicon.svg"
              alt="QueryZen"
            />
            <span className="ml-2 text-xl font-semibold text-gray-900">
              QueryZen
            </span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#problem" className="text-gray-600 hover:text-gray-900 transition-colors">
              Problem
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-gray-900 transition-colors">
              How It Works
            </a>
            <a href="#features" className="text-gray-600 hover:text-gray-900 transition-colors">
              Features
            </a>
            <a href="#contact" className="btn-primary">
              Get Early Access
            </a>
          </nav>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-600 hover:text-gray-900 focus:outline-none focus:text-gray-900"
              aria-label="Open menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
